import { TOGGLE_SIDEBAR, TOGGLE_PUBLICATION_SIDEBAR } from 'reducers/sidebar';

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});

export const togglePublicationSidebar = () => ({
  type: TOGGLE_PUBLICATION_SIDEBAR,
});
